import { render, staticRenderFns } from "./OrderComparison.vue?vue&type=template&id=416cd627&scoped=true"
import script from "./OrderComparison.vue?vue&type=script&lang=js"
export * from "./OrderComparison.vue?vue&type=script&lang=js"
import style0 from "./OrderComparison.vue?vue&type=style&index=0&id=416cd627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416cd627",
  null
  
)

export default component.exports